import { useNavigate } from "react-router-dom";
import { dummy_image } from "../../constant/import";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { IoReceipt } from "react-icons/io5";
import { useEffect } from "react";

const CompanyItem = (props: any) => {
  const { setSelectedorg } = useStateSetter();
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {

        navigate(`/home/${props.item.path}`);

      }}
      className="bg-white shadow-sm rounded-[10px] border border-customGray p-4 flex flex-col justify-center items-center"
    >
      <img src={props.item.img} />

      <p className="font-medium mt-2 text-textbg text-xs  cursor-pointer text-center ">
        {props.item.title}{" "}
      </p>
    </div>
  );
};

export { CompanyItem };
